import React from 'react';
import UserManagement from '../admin/UserManagement';

const TransporterPortal = () => (
    <UserManagement
        initialTab="TRANSPORTER"
        hideTabs={true}
        pageTitle="Transporter Portal"
        hideSecurity={true}
    />
);

export default TransporterPortal;
